'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'styles/WidgetProfile.scss';
import Avatar from 'components/base/Avatar';
import personUtils from 'services/people/personUtils';
import appConstants from 'constants/appConstants';

const propTypes = {
    error: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
};

class WidgetProfile extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        
        const avatar = this.props.person ? <Avatar className="avatar" profile={this.props.person} /> : <Avatar />;

        var style = null;
        if (this.props.profile) {
            style = {backgroundColor: personUtils.getAvatarColour(this.props.person.Id)};
        }
        
        return (
            <div id={this.props.id} className="widget-profile" style={style}>
                <div className="light-overlay">
                    {avatar}
                    <h4>{this.props.person ? personUtils.getFullName(this.props.person) : ''}</h4>
                </div>
            </div>
        );
    }
}

WidgetProfile.propTypes = propTypes;

export default WidgetProfile; 